// Sibling imports
const requireBridge = require('./shim')
const extension = require('client-v2/common/utils/extension')

function showAddUrlModal() {
  /**
   * @TODO Port wiggin add-url-modal to React
   * @see https://app.asana.com/0/0/1131079329757886/f
   */
  const AddUrlModal = require('client/components/add-url-modal')
  return AddUrlModal.promise()
}

function showArticleActionsModal(options) {
  const ArticleActionsModal = require('client/components/article-actions-modal')
  return ArticleActionsModal.confirmArticleAction(options)
}

function showAlertModal(options) {
  const ConfirmModal = require('client/components/confirm')
  return ConfirmModal.alert(options)
}

function showConfirmModal(options) {
  const ConfirmModal = require('client/components/confirm')
  return ConfirmModal.confirm(options)
}

function showMixEditModal(options) {
  const MixEditModal = require('client/components/mix-edit-modal')
  const {
    collectionDeleted,
    collectionEdited
  } = require('client-v2/common/models/collection/actions')
  return MixEditModal.promise(options)
  .then(result => {
    if (result.deleted) {
      app.store.dispatch(collectionDeleted(result.id))
    } else {
      app.store.dispatch(collectionEdited(result))
    }
  })
}

function showMixSelectModal(options) {
  const MixSelectModal = require('client/components/mix-select-modal')
  const { articleMixesUpdated } = require('client-v2/common/models/article/actions')
  return MixSelectModal.promise({
    ...options,
    changeCallback: ({ urlId, mixIds }) => {
      app.store.dispatch(articleMixesUpdated(urlId, mixIds))
      extension.clearUrlCache(urlId)
    }
  })
}

function showUserActionsModal(options) {
  const UserActionsModal = require('client/components/user-actions-modal')
  return UserActionsModal.confirmUserAction(options)
}

module.exports = {
  showAddUrlModal: requireBridge(showAddUrlModal),
  showAlertModal: requireBridge(showAlertModal),
  showArticleActionsModal: requireBridge(showArticleActionsModal),
  showConfirmModal: requireBridge(showConfirmModal),
  showMixEditModal: requireBridge(showMixEditModal),
  showMixSelectModal: requireBridge(showMixSelectModal),
  showUserActionsModal: requireBridge(showUserActionsModal)
}
